<template>
  <div class="maps">
    <div class="heard">
      <router-link to="/xingHanDaPing">
        <div class="img">
          <img src="../../../../assets/dapingImg/logo.png" alt />
        </div>
      </router-link>
      <span class="title">宏图业务</span>
      <div class="date">
        <span>{{ nowDate + ' ' + nowWeek }}</span>
      </div>
    </div>
    <!-- 颜色 -->
    <!-- <div class="lin_color"></div> -->
    <div class="container">
      <!-- 仓储数据 -->
      <div class="left">
        <div class="left_h">
          <span class="span_one">仓储数据</span>
          <span class="span_two">单位(吨)</span>
        </div>
        <div class="left_f">
          <div class="f1">
            <i>{{cangchuData.storge}}</i>
            <br />
            <span>总库存量</span>
          </div>
          <div class="f2 f1">
            <ul>
              <li>
                <i>{{cangchuData.dailyInStorage}}</i>
                <br />
                <span>日入库量</span>
              </li>
              <li>
                <i>{{cangchuData.dailyOutStorage}}</i>
                <br />
                <span>日出库量</span>
              </li>
            </ul>
          </div>
          <div class="f3 f1">
            <i>{{cangchuData.taotalNum}}</i>
            <br />
            <span>仓库数量</span>
          </div>
        </div>
      </div>
      <!-- 地图 -->
      <div class="center">
        <!--为echarts准备一个具备大小的容器dom-->
        <div id="map" :style="{width: '80vw', height: '85vh'}"></div>
      </div>
      <!-- 提货数据/ -->
      <div class="right">
        <div class="left_h">
          <span class="span_one">提货数据</span>
          <span class="span_two">单位(吨)</span>
        </div>
        <div class="left_f steel">
          <div class="f1">
            <i>{{tihuoData.historyWeight}}</i>
            <br />
            <span>历史提货总量</span>
          </div>
          <div class="f2 f1">
            <ul>
              <li>
                <i>{{tihuoData.dailyDelivery?tihuoData.dailyDelivery:0}}</i>
                <br />
                <span>日提货量</span>
              </li>
              <li>
                <i>{{tihuoData.dailyDepartures?tihuoData.dailyDepartures:0}}</i>
                <br />
                <span>日发车量</span>
              </li>
            </ul>
          </div>
          <div class="f3 f1">
            <i>{{tihuoData.billNum}}</i>
            <br />
            <span>历史提单数</span>
          </div>
        </div>
      </div>
      <!-- 船运数据 -->
      <!-- <div class="right_l">
        <div class="left_h boatsle">
          <span class="span_one">船运数据</span>
          <span class="span_two">单位(吨)</span>
        </div>
        <div class="left_f">
          <div class="f1">
            <i>{{shipBoatData.historyAllWeight}}</i>
            <br />
            <span>历史总发运量</span>
          </div>
          <div class="f2 f1">
            <ul>
              <li>
                <i>{{shipBoatData.shipallWeight}}</i>
                <br />
                <span>总运力</span>
              </li>
              <li>
                <i>{{shipBoatData.shipdayAllWeight}}</i>
                <br />
                <span>日发运量</span>
              </li>
            </ul>
          </div>
          <div class="f3 f1">
            <i>{{shipBoatData.shipCount}}</i>
            <br />
            <span>船舶数</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getTotalWeightList, getSocBillStatician } from '@/api/data-center-server'
import { tools } from '@/utils/echarts-tooltip-auto.js'
export default {
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '', // 当前星期
      charts: '',
      mapTimer: '',
      timer: '',
      cangchuData: {}, // 仓储数据
      tihuoData: {}, // 配货数据
      shipBoatData: {}, // 船舶数据
      // res: "",
      geoCoordMap: {}, // 经纬度
      steelData: [], // 流向数据
      shipData: [], // 船舶数据
      storageData: [] // 仓库数据
    }
  },
  // 销毁定时器
  beforeDestroy: function () {
    if (this.getDate) {
      // console.log("销毁定时器");
      clearInterval(this.getDate) // 在Vue实例销毁前，清除时间定时器
    }
  },
  created () {
    this.initKucun()// 提货数据
    this.currentTime()
  },
  async mounted () {
    await this.initData() // 初始化地图数据
    // 初始化echarts实例
    let myChart = this.$echarts.init(document.getElementById('map'))
    // 进行相关配置
    var planePath =
      'path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705'

    var color = ['#FDFD01', '#4DF442', '#FBAE00']
    var series = []
    let _this = this;
    [
      // ['流向', _this.steelData],
      // ["船舶", _this.shipData],
      ['仓库', _this.storageData]
    ].forEach(function (item, i) {
      series.push(
        {
          name: item[0],
          type: 'effectScatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: {
            brushType: 'stroke'
          },
          label: {
            normal: {
              show: true,
              fontSize: 0.1,
              position: 'right',
              formatter: '{b}'
            }
          },
          symbolSize: function (val) {
            return val[1] / 5
          },
          // zoom:1.6,
          itemStyle: {
            normal: {
              color: color[i]
            }
          },
          data: item[1].map(function (dataItem) {
            return {
              address: dataItem[0].address,
              storge: dataItem[0].storge,
              dailyInStorage: dataItem[0].dailyInStorage,
              dailyOutStorage: dataItem[0].dailyOutStorage,
              name: dataItem[0].name,
              value: [dataItem[0].longitude, dataItem[0].latitude]
            }
          })
        }
      )
    })
    this.chartOption = {
      tooltip: {
        // 鼠标移到图里面的浮动提示框
        // formatter详细配置： https://echarts.baidu.com/option.html#tooltip.formatter
        formatter (params, ticket, callback) {
          // params.data 就是series配置项中的data数据遍历
          let localValue, perf, downloadSpeep, usability, point
          if (params.data) {
            localValue = params.data.value
            perf = params.data.perf
            downloadSpeep = params.data.downloadSpeep
            usability = params.data.usability
            point = params.data.point
          } else {
            // 为了防止没有定义数据的时候报错写的
            localValue = 0
            perf = 0
            downloadSpeep = 0
            usability = 0
            point = 0
          }
          let htmlStr = `<div class="box" style=" background:rgba(3, 250, 236, 0.3);border: solid 1px rgba(3, 250, 236, 0.75);border-radius: 6px;padding:16px"> 
          <div style="margin-bottom:10px;font-size:16px">${params.name}</div>
          <div><span style="color:#fbad00;">日入：${params.data.dailyInStorage}吨</span><span style="margin-left:20px;color:#fe4830;">日出：${params.data.dailyOutStorage}吨</span></div>
          <div>库存：${params.data.storge}吨</div>
          <div>${params.data.address}</div>
          </div>`
          return htmlStr
        },
        backgroundColor: 'none', // 提示标签背景颜色
        textStyle: { color: '#03faec;' } // 提示标签字体颜色
      },
      legend: {
        orient: 'vertical',
        color: ['#fff'],
        bottom: 20,
        left: 300,
        data: ['流向', '船舶', '仓库'],
        textStyle: {
          color: '#fff'
        }
      },

      // geo配置详解： https://echarts.baidu.com/option.html#geo
      geo: {
        // 地理坐标系组件用于地图的绘制
        map: 'china', // 表示中国地图
        roam: true, // 是否开启鼠标缩放和平移漫游
        zoom: 1.2, // 当前视角的缩放比例（地图的放大比例）
        scaleLimit: { // 滚轮缩放的极限控制
          min: 1
        },
        label: {
          show: true,
          color: '#03faec'
        },
        itemStyle: {
          // 地图区域的多边形 图形样式。
          borderColor: 'rgba(0, 0, 0, 0.2)',
          normal: {
            areaColor: '#01145D', // 区域背景色 地图
            borderColor: '#03DBD9' // 每个区域的边框色
          },
          emphasis: {
            areaColor: '#02229b' // 区域背景色 点击后颜色
          }
        },
        emphasis: {
          label: {
            color: '#00FFFF'
          }
        }
      },
      series: series
    }
    myChart.setOption(this.chartOption)
    // 提示框轮播
    tools(myChart, this.chartOption, {
      loopSeries: true,
      interval: 10000
    })
    // 地图数据定时器 --》5分钟刷新
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(() => {
        this.initKucun()
      }, 1000 * 60 * 2)
    }
    if (this.mapTimer) {
      clearInterval(this.mapTimer)
    } else {
      this.mapTimer = setInterval(() => {
        this.initData()
      }, 1000 * 60 * 60)
    }
  },
  methods: {
    currentTime () {
      setInterval(this.getDate, 500)
    },
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    },
    // 获取地图流向
    async initData () {
      await getTotalWeightList({})
        .then(res => {
          this.cangchuData = res.wmsWeight
          this.storageData = []
          let storage = res.list
          // let ship = res.ship; //船舶
          // 仓库经纬度
          storage.forEach((item, index) => {
            let name = item.warehouseName
            let latitude = item.lat
            let longitude = item.lon
            this.geoCoordMap[name] = Array.of(longitude, latitude)

            let _storage = {}
            _storage['name'] = name
            _storage['latitude'] = item.lat
            _storage['longitude'] = item.lon
            _storage['value'] = 120
            _storage['dailyOutStorage'] = item.dailyOutStorage
            _storage['dailyInStorage'] = item.dailyInStorage
            _storage['address'] = item.address
            _storage['storge'] = item.storge
            this.storageData.push([_storage])
          })
          // //船舶经纬度
          // ship.forEach((item, index) => {
          //   let name = item.name;
          //   let latitude = item.latitude;
          //   let longitude = item.longitude;
          //   this.geoCoordMap[name] = Array.of(longitude, latitude);

          //   let _ship = {};
          //   _ship["name"] = name;
          //   _ship["value"] = 120;
          //   this.shipData.push([_ship]);
          // });

          let _storages = []

          // 流向数据
          // steel.forEach((item, index) => {
          //   let yname = item.yname
          //   let ylatitude = item.ylatitude
          //   let ylongitude = item.ylongitude
          //   this.geoCoordMap[yname] = Array.of(ylongitude, ylatitude)

          //   let tenantName = item.tenantName

          //   let _to = {}
          //   _to['name'] = tenantName

          //   let _from = {}
          //   _from['name'] = yname
          //   _from['value'] = 50
          //   this.steelData.push([_to, _from])

          //   if (_storages.indexOf(tenantName) == -1) {
          //     _storages.push(tenantName)
          //   }
          // })

          // _storages.forEach((item, index) => {
          //   let _storage = {}
          //   _storage['name'] = item
          //   _storage['value'] = 120
          //   this.steelData.push([_storage, _storage])
          // })

          // console.log(this.steelData);
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 提货数据
    initKucun () {
      getSocBillStatician({})
        .then(res => {
          this.tihuoData = res
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  destroyed () {
    clearInterval(this.timer, this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.map_heard {
  color: #03faec;
  font-weight: 700;
  font-size: 35px;
  position: absolute;
  left: 46%;
  top: 30px;
}
.heard {
  height: 100px;
  width: 100%;
  position: absolute;
  background:url('../../../../assets/dapingImg/标题光条.png') no-repeat center;
}
.maps {
  width: 100%;
  height: 100vh;
  // display: flex;
  overflow: hidden;
  background:url('../../../../assets/dapingImg/bg.png') 100%;

}
/*左右固定，中间自适应  利用绝对定位*/
.container {
  width: 100%;
  height: 100vh;
  position: relative;
}
.center {
  /*width: auto;*/ /*如果没有这一句，那么，center这个div的文字就不会自动换行*/
  margin: 0 0px;
  position: absolute;
  bottom: 10px;
  left:5%;
  // height: 800px;
  //   background-color: yellow;
}
.left {
  z-index: 100;
   border: 1px solid #063D69;

  background-size: 100%;
  position: absolute;
  left: 30px;
  top: 10vh;
  width: 15vmax;
  height: 30vh;

  //   color: #fff;
}
.left_h {
  height: 30px;
  line-height: 30px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
   border: 1px solid #063D69;

  //   opacity: 0.5;
  //
  //   background-color: #041650;
  .span_one {
    float: left;
    margin-left: 10px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.left_f {
  height: 26vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; /*由于flex-direction: column，因此align-items代表的是水平方向*/
  justify-content: center;
  .f1 {
    flex: 1;
    width: 100%;
    overflow: hidden;
    text-align: center;
  }

  ul {
    display: flex;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    li {
      flex: 1;
    }
  }
  i {
    font-weight: 700;
    font-size: 16px;
    color: yellow;
    padding: 0;
  }
  span {
    color: #fff;
  }
}
.steel {
  i {
    color: #11b8e0;
  }
  span {
    color: #fff;
  }
}
.boatsle {
  i {
    color: #c28836;
  }
  span {
    color: #03faec;
  }
}
.right {
  z-index: 100;
 border: 1px solid #063D69;
  // background: url("../../../../assets/dapingImg/mk-bg.png") no-repeat 100%;
  background-size: 100%;
  position: absolute;
  top: 10vh;
  right: 30px;
  width: 17vmax;
  height: 30vh;
  //   border: 1px solid #ccc;
}
.right_l {
  // background: url("../../../../assets/dapingImg/mk-bg.png") no-repeat 100%;
 border: 1px solid #063D69;

  background-size: 100%;
  position: absolute;
  bottom: 1vh;
  right: 30px;
  width: 17vmax;
  height: 30vh;
}
.heard {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  background: url("../../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .title {
    flex: 1;
    font-size: 30px;
    font-weight: 700;
    color: #03faec;
  }
  .date {
    font-size: 16px;
    color: #ffdd17;
  }
   .img{
    height: 6vh;
    position: absolute;
    z-index: 1111;
    img{
      height: 100%;
    }
  }
}

.lines {
  height: 300px;
  width: 380px;
  position: absolute;
  bottom: 20px;
  left: 10%;
  // background-color: red;
  .li1 {
    color: #fff;
    width: 100%;
    height: 50px;
    font-size: 20px;
    b {
      float: left;
    }
    .b1 {
      width: 100px;
    }
    .b2 {
      font-size: 23px;
      margin-left: 6px;
      color: #e40311;
    }
    .b3 {
      display: block;
      margin-left: 20px;
      background-image: linear-gradient(to right, #ff7c7c, #ff0404);
      height: 22px;
      width: 160px;
      border-radius: 20px;
    }
  }
  .li2 {
    color: #fff;
    width: 100%;
    height: 50px;
    font-size: 20px;
    b {
      float: left;
    }
    .b1 {
      width: 100px;
    }
    .b2 {
      font-size: 23px;
      margin-left: 6px;
      color: #fc8c1d;
    }
    .b3 {
      display: block;
      margin-left: 20px;
      background-image: linear-gradient(to right, #f7b92d, #fc8c1d);
      height: 22px;
      width: 140px;
      border-radius: 20px;
    }
  }
  .li3 {
    color: #fff;
    width: 100%;
    height: 50px;
    font-size: 20px;
    b {
      float: left;
    }
    .b1 {
      width: 100px;
    }
    .b2 {
      font-size: 23px;
      margin-left: 6px;
      color: #fcfb07;
    }
    .b3 {
      display: block;
      margin-left: 20px;
      background-image: linear-gradient(to right, #fcfc97, #fcfb07);
      height: 22px;
      width: 120px;
      border-radius: 20px;
    }
  }
  .li4 {
    color: #fff;
    width: 100%;
    height: 50px;
    font-size: 20px;
    b {
      float: left;
    }
    .b1 {
      width: 100px;
    }
    .b2 {
      font-size: 23px;
      margin-left: 6px;
      color: #3cf831;
    }
    .b3 {
      display: block;
      margin-left: 20px;
      background-image: linear-gradient(to right, #8df886, #3cf831);
      height: 22px;
      width: 80px;
      border-radius: 20px;
    }
  }
  .li5 {
    color: #fff;
    width: 100%;
    height: 50px;
    font-size: 20px;
    b {
      float: left;
    }
    .b1 {
      width: 100px;
    }
    .b2 {
      font-size: 23px;
      margin-left: 6px;
      color: #0ed4ff;
    }
    .b3 {
      display: block;
      margin-left: 20px;
      background-image: linear-gradient(to right, #90e5f8, #0ed4ff);
      height: 22px;
      width: 50px;
      border-radius: 20px;
    }
  }
}
.left_f ul li {
  flex: 1;
  text-align: center;
}
</style>
